<div class="fx-fill fx-layout-col">
  <div class="sheet-header">
    <div class="fx-layout-row fx-justify-start fx-align-baseline">
      <div class="sheet-title fx-flex-85-percent">
        <span>{{ asset?.toString() }}</span>
      </div>
      <div class="fx-flex-48">
        <div class="btn-container">
          <button (click)="closeAssetSidebar()" [disableRipple]="true"
            class="fx-layout-col fx-justify-center fx-align-center"
            id="close-sheet-button" mat-icon-button>
            <i class="mdi mdi-close sm"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="fx-layout-row">
      <restricted-icon-button (onClick)="deleteAsset()"
        [class]="'mdi mdi-delete sm'"
        [id]="'delete-button'"
        [matTooltip]="'BUTTON.DELETE' | translate"
        [permissions]="[Permission.DELETE_ASSET]">
      </restricted-icon-button>
      <workflow-buttons
        [entityType]="EntityType.ASSET"
        [view]="ManualWorkflowViewEnum.SIDEPANEL"
        [selectedEntityIds]="[asset?.id]">
      </workflow-buttons>
    </div>
  </div>
  <div class="sidebar-sheet fx-flex-grow" cdk-scrollable>
    <div class="sidebar-picture-container">
      <img id="sidebar-picture"
        [src]="image?.url || appConfig.PLACEHOLDER_CAROUSEL"
        alt="{{ image && (image.alt || 'LABEL.ALT_ASSET_MAIN_PICTURE') || 'LABEL.NO_ASSET_PICTURE' | translate }}"/>
    </div>
    <div class="page-sidebar">
      <div class="form-container">
        <div class="partial-section-body fx-layout-row fx-wrap">
          @for (tab of assetTabs; track tab) {
            <div class="field-single-container fx-flex-50-percent">
              <div class="field-builder-container">
                <div class="read-field-container">
                  <div class="field-row">
                    <div class="field-label sheet-link tab-link">
                      <span (click)="navigateToAssetSheet(tab.key)"> {{ tab.name | translate }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
